interface ChatEvent {
  type: 'message' | 'link_click' | 'call' | 'escalation';
  data: Record<string, any>;
  timestamp: Date;
}

class ChatAnalytics {
  private static instance: ChatAnalytics;
  private events: ChatEvent[] = [];

  private constructor() {}

  public static getInstance(): ChatAnalytics {
    if (!ChatAnalytics.instance) {
      ChatAnalytics.instance = new ChatAnalytics();
    }
    return ChatAnalytics.instance;
  }

  public trackEvent(type: ChatEvent['type'], data: Record<string, any>) {
    const event: ChatEvent = {
      type,
      data,
      timestamp: new Date()
    };

    this.events.push(event);
    this.persistEvent(event);
  }

  private persistEvent(event: ChatEvent) {
    // In a real implementation, this would send the event to a backend service
    console.log('Chat Analytics Event:', event);
  }

  public getEventsSummary() {
    return {
      totalEvents: this.events.length,
      messageCount: this.events.filter(e => e.type === 'message').length,
      linkClicks: this.events.filter(e => e.type === 'link_click').length,
      calls: this.events.filter(e => e.type === 'call').length,
      escalations: this.events.filter(e => e.type === 'escalation').length
    };
  }
}

export const chatAnalytics = ChatAnalytics.getInstance();
